@if (content.type === contentType.VIDEO && nativeVideoSrc) {
  <video
    #nativeVideo
    class="h-full min-h-[330px] w-full bg-black"
    controls
    preload="metadata"
    [src]="nativeVideoSrc"
    (loadedmetadata)="onNativeMetadataLoaded($event)"
    (timeupdate)="onNativeTimeUpdate($event)"
    (seeked)="onNativeTimeUpdate($event)"
    (pause)="onNativeTimeUpdate($event)"
    (ended)="onNativeEnded()"
  >
    <track kind="captions" srclang="pt-BR" label="Português" src="assets/mocks/videos/captions.vtt" default />
    <track kind="descriptions" srclang="pt-BR" label="Descrição de áudio" src="assets/mocks/videos/descriptions.vtt" />
  </video>
} @else if (safeEmbeddedUrl) {
  <iframe
    #videoFrame
    class="h-full min-h-[330px] w-full"
    title="Player de vídeo"
    loading="lazy"
    allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
    (load)="onEmbeddedFrameLoad()"
  ></iframe>
} @else {
  <div class="grid h-full min-h-[330px] place-items-center px-6 text-center text-lWhite/75">
    <p>Vídeo indisponível para esta aula.</p>
  </div>
}
